module.exports = __webpack_public_path__ + "static/media/hotel-10.11b17ea0.jpg";